/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function setBackgroundTextMode({ pages, ...rest }) {
  return {
    pages: pages.map(reducePage),
    ...rest,
  };
}

function reducePage({ elements, ...rest }) {
  return {
    elements: elements.map(updateElement),
    ...rest,
  };
}

function updateElement(props) {
  const { type } = props;

  if (type === 'text') {
    const { backgroundColor } = props;
    const hasBackgroundColor =
      backgroundColor && backgroundColor !== 'transparent';

    return {
      backgroundTextMode: hasBackgroundColor ? 'FILL' : 'NONE',
      ...props,
    };
  }

  return props;
}

export default setBackgroundTextMode;
